import { StreamActions } from "@hotwired/turbo"

StreamActions.flash_message = function () {
  // Just get the HTML from the template - should be a flash message.  Stick
  // it in the #flash-messages div
  const flash_message = this.templateContent.children[0];
  console.log(this.templateContent);

  const flash_messages_div = document.getElementById("flash-messages")

  if (flash_message && flash_messages_div) {
    flash_messages_div.appendChild(flash_message)
  }
}
